<template>
  <BaseListPage
      :name="name"
      :no-condition="false"
      :base-query="baseQuery"
      :store-path="storePath"
      :response-path="responsePath"
      :save-key="saveKey"
      :table-set-list="tableSetList"
      :table-data-list="sortedList"
      title="権限ロール一覧"
      title-class="authority-header"
      icon="account"
      table-class="row-clickable-table"
      @row-click="onRowClick">
    <span slot="headerAction"
        class="action_button">
      <el-dropdown
          v-show="$isFunctionShown(define.PermissionKeys.Account.PermissionRole.Detail.NEW)"
          @command="actionCommand">
        <el-button size="small">
          アクション
          <i class="el-icon-arrow-down el-icon--right" />
        </el-button>
        <el-dropdown-menu
            slot="dropdown"
            class="header-action-menu">
          <el-dropdown-item
              :disabled="$isFunctionDisabled(define.PermissionKeys.Account.PermissionRole.Detail.NEW)"
              :command="define.ROLE_MODE.NEW">
            新規登録
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </span>
  </BaseListPage>
</template>

<script>
import _ from 'lodash'
import { mapState, mapGetters } from 'vuex'

import * as define from '@/define'
import * as query from '@/queries/permissionRole'
import x from '@/components/mixins/mixin'

import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'

import BaseListPage from '@/components/organisms/BaseListPage'

export default {
  name: 'PermissionRoleList',
  components: {
    BaseListPage
  },
  mixins: [x],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  computed: {
    define: () => define,
    ...mapState({
      listIndex: (state) => state.Account.listIndex,
      tableSetList: (state) => state.PermissionRole.tableSetList
    }),
    ...mapGetters({
      getSortedList: 'sortedList'
    }),
    ...mapGetters('LocalStorage', {
      sortCondition: 'sortCondition'
    }),
    name () {
      return 'permissionRoleList'
    },
    storePath () {
      return 'PermissionRole'
    },
    saveKey () {
      return 'permissionRoleCondition'
    },
    responsePath () {
      return 'data.permissionRoles'
    },
    linkKey () {
      return 'uuid'
    },
    returnPath () {
      return '/permissionrole'
    },
    baseQuery () {
      return query.GRAPH_QL_QUERY_PERMISSION_ROLE_LIST
    },
    sortedList () {
      return this.getSortedList(this.storePath, this.sortCondition(this.name))
    },
    _tableSetList () {
      return [
        { type: 'String', label: 'ロール名称', path: 'name', sortable: 'custom', funcId: define.PermissionKeys.Account.PermissionRole.List.NAME },
        { type: 'String', label: 'ロール種類', path: '権限', elementType: ELEMENT_TYPE.FIXED_TEXT, funcId: define.PermissionKeys.Account.PermissionRole.List.TYPE }
      ]
    }
  },
  created () {
    this.$store.dispatch({
      type: 'set',
      states: {
        'PermissionRole/tableSetList': this._tableSetList
      }
    })
  },
  methods: {
    onRowClick (row, column, event) {
      const id = _.get(row, this.linkKey)
      const index = this.$_mixin_findIndex(this.sortedList, { [this.linkKey]: id })
      this.$_mixin_onLinkClick(index, this.storePath)
      this.$router.push({ path: `/permissionrole/${id}` })
    },
    /**
     * アクションボタン
     * @param {Number} mode モード
     */
    actionCommand: async function (mode) {
      switch (mode) {
        case define.ROLE_MODE.NEW:
          this.createPermissionRole()
          break
        default:
          break
      }
    },
    createPermissionRole () {
      this.$_mixin_onLinkClick(this.listIndex, this.storePath, define.ROLE_MODE.NEW)
      this.$router.push({ path: 'permissionrole/0' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/account/PermissionRoleListTop.vue